export const numberWithCommas = (x: number): string => {
  const parts = x.toFixed(2).toString().split('.');
  parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts.join(',');
};

export const formatNetUnitPrice = (value: number): string =>
  new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 6 }).format(value);

export const currencyStringToNumber = (
  str: string,
  currencySymbol: string,
): number => {
  const regex = new RegExp(
    '(\\d{1,3}(\\.\\d{3})*)(\\,\\d+)\\s+' + currencySymbol,
    'g',
  );

  const replaced = Number(
    str.replace(
      regex,
      (_, p1, __, p3) => p1.replace(/\./g, '') + p3.replace(',', '.'),
    ),
  );

  return replaced;
};

export const toFixedCurrency = (val: number, precision: number) =>
  (+(Math.round(+(val + 'e' + precision)) + 'e' + -precision)).toFixed(
    precision,
  );
